<template>
  <b-row>
    <b-col class="container text-right">
    </b-col>

    <b-card class="mt-2 col-12">
      <b-tabs>
        <b-tab
          v-for="tab in tabs"
          :key="tab.title"
          :title="tab.title"
          lazy
          @click.prevent="setActiveTabName(tab.mode)"
        >
          <b-col cols="12">
            <SearchFilter
              :mode="tab.mode"
              @handleSubmit="searchFilterSubmit"
              ref="searchFilterComponent"
            />
          </b-col>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-col v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
      <commonTable
        ref="tableCommon"
        :mode="tab"
        :rows="userList"
        @handle-select="onSelectChange"
        @swapUp="swapUpRoot"
        @swapDown="swapDownRoot"
        @deleteRow="deleteRowRoot"
      />
    </b-col>



    <ModalAddUser
      ref="modalAddUser"
      :users="userAddList"
      @handle-submit="onAddUserSubmit"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import commonTable from "./components/commonTable.vue";
import SearchFilter from "./components/SearchFilter.vue";
import ModalAddUser from "./components/ModalAddUser.vue";

import * as roleStore from "@/store/api/role/index.js";
import * as AssignWorkOrder from "@/store/api/AssignWorkOrder/index.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    commonTable,
    SearchFilter,
    ModalAddUser,
    AssignWorkOrder
  },
  data() {
    return {
      tabs: [{ title: "จัดการผู้ใช้งาน", mode: "List" }],
      activeTab: ["List"],
      userAddList: [],
      userList: [],
      selects: [],
    };
  },
  created() {
    this.loadTable();
  },
  methods: {
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    onSelectChange(selects) {
      this.selects = selects;
    },
    // onRemoveUserClicked() {
    //   const userIds = this.selects.map((value) => value.userId);

    //   const _this = this;

    //   console.log("userIds", userIds);

    //   if (userIds.length === 0) {
    //     this.$bvToast.toast("กรุณาเลือกผู้ใช้งานที่จะลบออกจากกลุ่มสิทธิ์", {
    //       title: `กรุณาเลือกผู้ใช้งานที่จะลบออกจากกลุ่มสิทธิ์อย่างน้อย 1 รายการ`,
    //       variant: "danger",
    //       solid: false,
    //     });

    //     return;
    //   }

    //   this.$swal({
    //     title: "คุณต้องการลบผู้ใช้งานออกจากกลุ่มสิทธิ์ใช่หรือไม่?",
    //     text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
    //     icon: "warning",
    //     showCancelButton: true,
    //     confirmButtonText: "ลบข้อมูล",
    //     customClass: {
    //       confirmButton: "btn btn-primary",
    //       cancelButton: "btn btn-outline-danger ml-1",
    //     },
    //     buttonsStyling: false,
    //   }).then((result) => {
    //     if (result.value) {
    //       const params = {
    //         roleId: this.$route.query.id,
    //         userIds,
    //         userId: userData.userId(),
    //       };

    //       roleStore
    //         .removeRoleUserList(params)
    //         .then((response) => {
    //           if (response.data.success === true) {
    //             _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
    //               title: `ระบบได้ลบผู้ใช้งานออกจากกลุ่มสิทธิ์แล้ว`,
    //               variant: "success",
    //               solid: false,
    //             });

    //             //_this.$refs.searchFilter.onSearchBtnClicked();

    //             _this.getCurrentRoleUser();
    //           } else {
    //             _this.$bvToast.toast("เกิดข้อผิดพลาด", {
    //               title: `เกิดข้อผิดพลาด`,
    //               variant: "danger",
    //               solid: false,
    //             });
    //           }
    //         })
    //         .catch((error) => {
    //           _this.$bvToast.toast("เกิดข้อผิดพลาด", {
    //             title: `เกิดข้อผิดพลาด`,
    //             variant: "danger",
    //             solid: false,
    //           });
    //           console.log("error", error);
    //         });
    //     }
    //   });
    // },


    swapUpRoot(userId) {
      const _this = this;

      const params = {
        departId: userData.departmentId(),
        UserId: userId
      };

      AssignWorkOrder
        .SwapUp(params)
        .then((response) => {
          _this.loadTable();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    swapDownRoot(userId) {
      const _this = this;

      const params = {
        departId: userData.departmentId(),
        UserId: userId
      };


      AssignWorkOrder
        .SwapDown(params)
        .then((response) => {
          _this.loadTable();
        })
        .catch((error) => {
          console.log("error", error);
        });

      
    },
    deleteRowRoot(userId) {
      const _this = this;
      


      this.$swal({
        title: "คุณต้องการลบข้อมูลใช่หรือไม่?",
        text: "เมื่อลบแล้วไม่สามารถกู้คืนได้อีก!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ลบข้อมูล",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const params = {
        departId: userData.departmentId(),
        UserId: userId
      };

      AssignWorkOrder
        .DeleteRow(params)
        .then((response) => {
          _this.loadTable();
        })
        .catch((error) => {
          console.log("error", error);
        });
        }
      });

      
    },

    loadTable() {
      const _this = this;

      const params = {
        departId: userData.departmentId(),
      };

      AssignWorkOrder
        .GetDepartUserList(params)
        .then((response) => {
          console.log("response", response.data.data);
          _this.userList = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    searchFilterSubmit(params) {
      //this.$refs.tableCommon.onSearchSubmit(params)
      //this.$route.query.id
      const _this = this;

      params.departId = userData.departmentId();

      AssignWorkOrder
        .GetDepartUserAddList(params)
        .then((response) => {
          _this.userAddList = response.data.data;

          _this.$refs.modalAddUser.$refs["modal-add-user"].show();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onAddUserSubmit(selects) {
      console.log("selects",selects)
      const _this = this;

      const userIds = selects.map((value) => value.userId);

      const params = {
        userIds,
        DepartmentId: userData.departmentId(),
        userId: userData.userId(),
      };

      AssignWorkOrder
        .AddDepartUserList(params)
        .then((response) => {
          if (response.data.success === true) {
            _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกเพิ่มผู้ใช้งานเข้ากลุ่มสิทธิ์แล้ว`,
              variant: "success",
              solid: false,
            });

            console.log('_this.refs', _this.$refs)

            _this.$refs.searchFilterComponent[0].onSearchBtnClicked();

            _this.loadTable();
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาด`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch((error) => {
          _this.$bvToast.toast("เกิดข้อผิดพลาด", {
            title: `เกิดข้อผิดพลาด`,
            variant: "danger",
            solid: false,
          });
          console.log("error", error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
